import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

const site = process.env.REACT_APP_BUILD_SITE;

const getColorCalendar = () => {
  if (site === 'VAMX') return '#84bbda';
  if (site === 'CMBR') return '#5a89a3';
  if (site === 'UBPE') return '#6dac9e';
  return '#fc9764';
};

const StyledDatapicker = styled.div`
  max-height: 50px;
  overflow: normal;
  .CustomCalendar {
    font-family: 'Hind';
    font-size: 14px;
    border: 1px solid ${select('midDarkGray')};
    border-radius: 8px;
  }
  .react-datepicker__header {
    border: 0;
    padding-top: 0;
  }
  .customdayClassName,
  .react-datepicker__day-names > div {
    padding: 5px 10px;
    width: 3.2rem;
    height: 3.2rem;
    line-height: 2.3rem;
    margin: 0;
  }
  .react-datepicker__day-names {
    background: ${select('lightGray')};
    text-transform: capitalize;
    font-size: 12px;
  }
  .react-datepicker__month {
    background: white;
    margin: 8px 15px;
  }
  .react-datepicker__day--outside-month {
    color: ${select('midDarkGray')};
  }
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range {
    background: ${getColorCalendar()} !important;
    border-radius: 0%;
    color: white !important;
    opacity: 1;
  }

  .customdayClassName:active,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--selected,
  .react-datepicker__day--selected:hover,
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-start:hover,
  .react-datepicker__day--range-end,
  .react-datepicker__day--range-end:hover {
    background: ${getColor('primary')} !important;
    color: white !important;
    border-radius: 4px !important;
  }
  .react-datepicker__day--keyboard-selected,
  .react-datepicker__day--keyboard-selected:hover {
    border-radius: 4px;
    background: none;
    color: black;
    font-weight: normal;
  }
  .react-datepicker__day--today,
  .react-datepicker__day--today:hover {
    background: ${({ disabledColor }) => (disabledColor ? 'none' : getColor('primary'))};
    color: ${({ disabledColor }) => (disabledColor ? 'black' : 'white')};
    border-radius: 4px;
  }
  /* .react-datepicker__day:hover, */
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    border-radius: 0%;
    background: ${select('middleGray')};
  }
  .react-datepicker__header {
    background: ${select('middleGray')};
    border-radius: 8px;
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {
    border-bottom-color: ${select('middleGray')};
  }
  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle:before {
    border-bottom-color: ${select('midDarkGray')};
  }
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    cursor: not-allowed;
  }
  .react-datepicker__day--disabled,
  .react-datepicker__month-text--disabled,
  .react-datepicker__quarter-text--disabled,
  .react-datepicker__year-text--disabled {
    color: ${select('midDarkGray')};
  }
  .react-datepicker__day--outside-month {
    visibility: hidden;
  }
  .react-datepicker__day--today {
    font-weight: normal;
  }

  /* .react-datepicker__today-button {
    background: #f3f7f8;
    color: gray;
    border-top: 1px solid #aeaeae;
    cursor: auto;
    pointer-events: none;
    text-align: center;
    font-weight: normal;
    padding: 2px 0;
  } */
`;

export default StyledDatapicker;
